/* Custom Lithium blog articles: reading progress, contents list, wide photos, photo viewer, copy link. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-cl-article]');
    if (!root || root.__cl) return;
    root.__cl = true;
    var body = root.querySelector('[data-cl-body]');
    if (!body) return;

    // 1. Tidy up: remove images with no picture (left behind by the editor) and paragraphs left empty
    Array.prototype.slice.call(body.querySelectorAll('img')).forEach(function (img) {
      var src = (img.getAttribute('src') || '').trim();
      if (!src || src === '<>' || /\/%3C%3E$|\/<>$/.test(src)) img.remove();
    });
    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
      if (!p.textContent.replace(/\u00a0/g, ' ').trim() && !p.querySelector('img,iframe,video,svg')) p.remove();
    });

    // 2. Paragraphs that only hold photos run wider than the text
    Array.prototype.slice.call(body.querySelectorAll('p, div')).forEach(function (el) {
      if (el.querySelector('img') && !el.textContent.replace(/\u00a0/g, ' ').trim() && el.parentElement === body) el.classList.add('cl-wide');
    });

    // 3. Contents list from the headings
    var toc = root.querySelector('[data-cl-toc]');
    if (toc) {
      var min = parseInt(toc.getAttribute('data-min') || '3', 10);
      var heads = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
      if (heads.length >= min) {
        var used = {};
        var items = heads.map(function (h) {
          var id = h.id || h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
          while (used[id]) id += '-2';
          used[id] = true;
          h.id = id;
          return '<li' + (h.tagName === 'H3' && heads.some(function (x) { return x.tagName === 'H2'; }) ? ' class="cl-toc__sub"' : '') + '><a href="#' + id + '">' + h.textContent.replace(/[<>&]/g, '') + '</a></li>';
        });
        toc.querySelector('ol').innerHTML = items.join('');
        toc.hidden = false;
        if (window.matchMedia('(min-width: 900px)').matches) toc.setAttribute('open', '');
      }
    }

    // 4. Reading progress
    var bar = document.querySelector('[data-cl-progress]');
    if (bar) {
      var raf = 0;
      var update = function () {
        raf = 0;
        var r = body.getBoundingClientRect(), vh = window.innerHeight;
        var total = r.height - vh * 0.6;
        var done = total > 0 ? Math.min(1, Math.max(0, (-r.top + vh * 0.2) / total)) : 0;
        bar.style.width = (done * 100).toFixed(1) + '%';
      };
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      update();
    }

    // 5. Photo viewer
    var imgs = Array.prototype.slice.call(body.querySelectorAll('img')).filter(function (i) { return !i.closest('a'); });
    if (imgs.length) {
      var box = document.createElement('div');
      box.className = 'cl-lightbox'; box.hidden = true;
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Photo viewer');
      box.innerHTML = '<img alt=""><button class="cl-lightbox__close" aria-label="Close">\u00d7</button><button class="cl-lightbox__prev" aria-label="Previous photo">\u2039</button><button class="cl-lightbox__next" aria-label="Next photo">\u203a</button><div class="cl-lightbox__count"></div>';
      document.body.appendChild(box);
      var big = box.querySelector('img'), count = box.querySelector('.cl-lightbox__count'), cur = 0, lastFocus = null;
      var full = function (src) { return src.replace(/_(small|medium|large|grande|\d+x\d*)(?=\.\w+(\?|$))/i, '').replace(/([?&])width=\d+/, '$1width=2000'); };
      var show = function (i) {
        cur = (i + imgs.length) % imgs.length;
        big.src = full(imgs[cur].currentSrc || imgs[cur].src);
        big.alt = imgs[cur].alt || '';
        count.textContent = (cur + 1) + ' of ' + imgs.length;
        var many = imgs.length > 1;
        box.querySelector('.cl-lightbox__prev').hidden = !many; box.querySelector('.cl-lightbox__next').hidden = !many;
      };
      var open = function (i) { lastFocus = document.activeElement; show(i); box.hidden = false; document.documentElement.style.overflow = 'hidden'; box.querySelector('.cl-lightbox__close').focus(); };
      var close = function () { box.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); };
      imgs.forEach(function (img, i) {
        img.setAttribute('tabindex', '0');
        img.setAttribute('role', 'button');
        if (!img.getAttribute('aria-label')) img.setAttribute('aria-label', 'Open photo ' + (i + 1) + ' full screen');
        img.addEventListener('click', function () { open(i); });
        img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
      });
      box.addEventListener('click', function (e) {
        if (e.target.closest('.cl-lightbox__close') || e.target === box) close();
        else if (e.target.closest('.cl-lightbox__prev')) show(cur - 1);
        else if (e.target.closest('.cl-lightbox__next')) show(cur + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
    }

    // 6. Copy link
    var copy = root.querySelector('[data-cl-copy]');
    if (copy) copy.addEventListener('click', function () {
      var done = root.querySelector('[data-cl-copied]');
      var finish = function () { if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 2200); } };
      if (navigator.clipboard) navigator.clipboard.writeText(copy.getAttribute('data-url')).then(finish, finish); else finish();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
